// extracted by mini-css-extract-plugin
export default {"searchData":"SearchPage_searchData__j7jUA"};